<template>
  <v-container>
    <v-row>
      <v-col>
        <v-sheet>
          <v-row justify="center">
            <v-col md="6">
              This is the homepage of the TERENO DOI landing site.
              You can search for a DOI in the input field below.
              The input field supports a
              <a href="https://www.elastic.co/guide/en/elasticsearch/reference/current/query-dsl-query-string-query.html#query-string-syntax" target="_blank">
                query string syntax
              </a>.
            </v-col>
          </v-row>
          <v-row justify="center" no-gutters>
            <v-col md="4">
              <v-text-field
                v-model="searchField"
              />
            </v-col>
          </v-row>
          <v-row justify="center">
            <div class="text-h6">Publications {{foundPublicationsDescription}}</div>
          </v-row>
          <v-row justify="center">
            <v-overlay
              absolute
              opacity="0.1"
              :value="isLoading"
            >
              <div class="text-center">
                <v-progress-circular
                  indeterminate
                  color="primary"
                />
                <div>Loading ...</div>
              </div>
            </v-overlay>

            <v-list v-if="foundDois" class="publication-list">
              <v-list-item
                v-for="doi in foundDois"
                :key="doi.id"
              >
                <v-list-item-avatar>
                  <v-icon large color="primary">mdi-note-text</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <doi-citation :metadata="doi.attributes"></doi-citation>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <div v-else>
              None.
            </div>
          </v-row>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import dataciteServices from '@/shared/services/datacite-services'
import { models } from 'vue-component-library'
import DoiCitation from '@/shared/components/doi-citation-component'

const { applicationStateModel } = models

export default {
  name: 'HomePage',
  components: { DoiCitation },
  data () {
    return {
      isLoading: false,
      timeoutHdl: undefined,
      searchField: '',
      searchResult: undefined
    }
  },
  computed: {
    doisFound () {
      return this.foundDois?.length
    },
    foundPublicationsDescription () {
      return this.foundDois && `(${this.foundDois?.length} of ${this.searchResult?.meta.total})`
    },
    foundDois () {
      return this.searchResult?.data
    }
  },
  watch: {
    async searchField (value) {
      if (!value) {
        return
      }
      this.timeoutHdl && clearTimeout(this.timeoutHdl)
      this.timeoutHdl = setTimeout(async () => {
        this.isLoading = true
        try {
          this.searchResult = await dataciteServices.findDoi({
            query: value,
            sort: 'name'
          })
        } catch (exception) {
          if (exception.code !== 20) { // no user abort
            applicationStateModel.addError(exception)
            this.isLoading = false
          }
        }
        this.isLoading = false
      }, 300)
    },
  }
}
</script>

<style scoped>
.publication-list {
  max-height: calc(100vh - 340px);
  overflow-y: auto;
}
</style>
